import { Page } from '@/components/layout';
import { EVENTS_BY_SLUG, formatDateRangeLong } from '@/features/events';
import { HeroBogota } from './sections/HeroBogota';
import { BenefitsRowBogota } from './sections/BenefitsRowBogota';
import { InvitadosBogota } from './sections/InvitadosBogota';
import { CamaraCuanticaBogota } from './sections/CamaraCuanticaBogota';
import { LowerGridBogota } from './sections/LowerGridBogota';
import { PruebaSocialBogota } from './sections/PruebaSocialBogota';
import { FaqBogota } from './sections/FaqBogota';
import { SiguienteNivelBogota } from './sections/SiguienteNivelBogota';
import { MantraBogota } from './sections/MantraBogota';
import { CancunUpsell } from '@/pages/shared/BriefBlocks';
import { CtaBand, PorQueIr, ReservaCta } from '@/pages/shared/ConversionBlocks';

/* =============================================================================
 * /bogota · «Sanación de la Consciencia y Frecuencia Origen» · 13-14 febrero 2027
 * -----------------------------------------------------------------------------
 * Dueño: FORGE-DELTA. Mockup: `DEMO_2_Bogota.png`. Guía: doc 02 §8.
 * Mapa de secciones medido: `docs/sections/BOGOTA_SECTION_MAP.md`.
 *
 *   S1 Hero            0–41,5 %   foto a sangre (montaña + iglesia) + retrato
 *   S2 Beneficios     41,5–51,4 % 4 columnas con filetes dorados
 *   S3 Cámara         51,5–68,2 % texto + cubo octogonal resplandeciente
 *   S4 Zona baja      68,2–89,5 % cronograma · Azrahel · entradas
 *   S5 Mantra         89,6–100 %  panorámica + mantra centrado
 *
 * ADICIONES EXIGIDAS POR EL BRIEF (ADR-006), que el mockup NO dibuja y que van
 * antes del cierre, construidas con su mismo lenguaje visual:
 *
 *   S6 Prueba social  foto real de Miami 2023, sin cifras ni testimonios
 *   S7 FAQ local      las 9 preguntas de `event.faq`, con lo pendiente marcado
 *   S8 Siguiente nivel upsell a Cancún + enlace «volver a la gira»
 *
 * Declaradas en `docs/VISUAL_DEVIATIONS.md`.
 *
 * Todo el dato comercial (fechas, título, promesa, beneficios, programa, estado
 * de venta) sale de `@/features/events`. En esta página no hay ni una fecha, ni
 * un horario, ni un precio tecleado a mano.
 * ========================================================================== */
export function BogotaPage() {
  const event = EVENTS_BY_SLUG.bogota;

  return (
    <Page
      documentTitle={`${event.city} · ${event.title}`}
      description={`${event.title}. ${event.city}, ${event.country} · ${formatDateRangeLong(event)}. ${event.tagline}`}
      tone={event.heroTone}
    >
      <HeroBogota event={event} />
      {/* S1.bis y S1.ter · LA MISMA ESTRUCTURA QUE BUENOS AIRES (encargo del
          cliente, 28-jul-2026): CTA de reserva con detalle pegado al hero, y
          debajo el «por qué ir» con la foto de la Cámara DE BOGOTÁ y el gancho
          que el cliente escribió para esta ciudad. */}
      <ReservaCta event={event} />
      {/* Invitada especial y colaborador, encargo del cliente (17-sep-2026):
          «allí donde está el ratón», entre la reserva y la fila de beneficios. */}
      <InvitadosBogota />
      <BenefitsRowBogota event={event} />
      <CamaraCuanticaBogota />
      {/* El cronograma de Bogotá vive en la primera columna de esta rejilla, con
          sus horas. La banda de CTA y el «por qué ir» van detrás, en el mismo
          orden que en Buenos Aires. */}
      <LowerGridBogota event={event} />
      <CtaBand event={event} />
      <PorQueIr event={event} background="alt" />
      <PruebaSocialBogota />
      {/* El cierre del recorrido, en la MISMA forma que en Buenos Aires. Antes
          Bogotá tenía el suyo propio dentro de `SiguienteNivelBogota` —tarjeta
          centrada, sin foto—, así que el mismo escalón del embudo se contaba de
          tres maneras distintas en cuatro ciudades. */}
      <CancunUpsell desde={event} />
      <FaqBogota event={event} />
      <SiguienteNivelBogota />
      <MantraBogota />
    </Page>
  );
}
